import { IDaySize, setClass, useViewModel } from '@utils';
import { CalendarViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import React, { FC, useCallback } from 'react';
import { Day } from './Day';
interface RowProps {
  rowIndex: number;
  size: IDaySize;
}

export const Row: FC<RowProps> = observer(({ rowIndex, size }) => {

  const calendarViewModel = useViewModel(CalendarViewModel);

  const setActiveDay = useCallback((day: string) =>
    calendarViewModel.setActiveDay(day)
    , []);

  const getClassName = useCallback((day: Date) =>
    setClass('day-number', calendarViewModel.isCurrentMonth(day) && 'current-month', calendarViewModel.isDayActive(day) && 'current-day')
    , [calendarViewModel.today]);

  return (
    <div className='row'>
      {calendarViewModel.viewCalendar.map((day: Date, index: number) => (
        index < (rowIndex) * 7 && index >= (rowIndex - 1) * 7 && (
          <Day
            key={day.toLocaleDateString()}
            className={getClassName(day)}
            currentDay={day}
            isActiveDay={calendarViewModel.activeDay === day.toLocaleDateString()}
            size={size}
            setActiveDay={setActiveDay}
            getMeetings={(day: Date) => calendarViewModel.filteredMeetings.get(day.toDateString())}
            workCalendarDay={calendarViewModel.findWorkCalendarDay(day)}
          />
        ))
      )}
    </div>
  );
});
